import React from "react";

import useBook from "../../hooks/useBook";

import ArchiveCanvas from "../../shared_comp/ArchiveCanvas";
import SectionTitle from "../../shared_comp/SectionTitle";
import MainCanvas from "../../shared_comp/MainCanvas";

import NumeroList from "../../shared_comp/NumeroList";

const StatisticsMain = () => {
  
  const [received, setReceived] = React.useState(false)
  const [booksCatalogue, setBooksCatalogue] = React.useState<any>([])

  React.useEffect(() => {
    const receiveData = async () => {
      const res = await useBook.getBookList("statistics");
      setBooksCatalogue(res.books)
      setReceived(true)
    }
    receiveData()
  }, [])

  console.log("Statistics", booksCatalogue)

  return (
    <ArchiveCanvas>
      <SectionTitle title="정부자료 / 통계연보" />
      <MainCanvas>
        {received && (
          <NumeroList 
            numerolist={booksCatalogue} 
            sortoption={"publish_year"} 
            cat={"statistics"}/>
        )}
      </MainCanvas>
    </ArchiveCanvas>
  );
};
export default StatisticsMain;
